import { gql } from "@apollo/client";

export const GET_ALL_ACTIVE_STORE = gql`
  query GetActiveStoreItems($paginationArgs: IPaginationArgs!) {
    getActiveStoreItems(paginationArgs: $paginationArgs) {
      id
      name
      description
      imageUrl
      price
      type
      item
      status
      isForKids
      ownerId
      storeItemCategoryId
      owner {
        name
        avatar
      }
    }
  }
`;

export const GET_STORE_ITEM = gql`
  query GetStoreItem($getStoreItemId: String!) {
    getStoreItem(id: $getStoreItemId) {
      id
      name
      price
      type
      item
      imageUrl
      description
      owner {
        avatar
        name
        bio
      }
    }
  }
`;

export const GET_ALL_USER_STORE_ITEM = gql`
query GetAllUserPurchasedStoreItems($paginationArgs: IPaginationArgs!) {
  getAllUserPurchasedStoreItems(paginationArgs: $paginationArgs) {
    id
    storeItemId
    deliveryAddress
    deliveryStatus
    userId
    user {
      id
      name
      email
    }
  }
}
`;


export const PURCHASE_STORE_ITEM = gql`
query PurchaseStoreItem($itemId: String!, $quantity: Float!) {
  purchaseStoreItem(itemId: $itemId, quantity: $quantity)
}
`;


export const GET_STORE_ITEM_CATEGORIES = gql `
query FetchStoreItemCategories {
  fetchStoreItemCategories {
    categoryName
    id
  }
}
`